import { useEffect, useRef } from 'react'

/**
 * Retains the last known non-null/undefined value. Provide a `defaultValue` to
 * handle the where the value initially is null/undefined.
 *
 * @example
 * ```ts
 * const { optionalValue } = props // type number | undefined
 * const value = useLastDefined(optionalValue, 0) // type number
 * ```
 */
export const useLastDefined = <T>(value: T | undefined | null, defaultValue: T): T => {
	const ref = useRef<T>(value ?? defaultValue)
	useEffect(() => {
		if (value === undefined || value === null) return

		ref.current = value
	}, [value])

	return value ?? ref.current
}
